import { render, staticRenderFns } from "./RecipientDrawer.vue?vue&type=template&id=e548b65e"
import script from "./RecipientDrawer.vue?vue&type=script&lang=js"
export * from "./RecipientDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports